import React from 'react';

/*
    - ihoDesignSystem
*/
import { Alert, Badge, Box, Button, Grid, Image, Modal, Typography } from '@iho-design-system/Loader';

/*
    - icon
*/
import ObserverSVG from '../../../assets/images/icons/observer.svg';
import EmptySVG from '../../../assets/images/icons/empty.svg';
import PaginationRightSVG from '../../../assets/images/icons/pagination-right.svg';
import PaginationLeftSVG from '../../../assets/images/icons/pagination-left.svg';
import ChevronDownBlue from '../../../assets/images/icons/chevron-down-blue.svg';
import LoadingCustomSVG from '../../../assets/images/icons/loading-custom.svg';

/*
    - api
*/
import getApi from '../../../api/get';

const List = ({ props, paginationProps }) => {

    /*
       - defaultData
    */
    const [subOrganizationsResult, setSubOrganizationsResult] = React.useState('loading');
    const [subAllBalancesFromOrganizationResult, setAllBalancesFromOrganizationResult] = React.useState('empty');
    const [subOrganizationsOfOrganizationResult, setSubOrganizationsOfOrganizationResult] = React.useState({});

    React.useEffect(() => {
        if (props.members !== '') {
            if (props.members.status === 200 && props.subOrganizations.data.Data.length > 0) {
                setSubOrganizationsResult(props.subOrganizations.data);
            } else {
                setSubOrganizationsResult('empty');
            }
        }
    }, [props]);

    /*
        - allBalancesFromOrganization
    */
    const allBalancesFromOrganizationHandler = async (value) => {
        let parameters = {
            ctrl: 'financial',
            method: 'GetAllBalancesFromOrganization',
            query: value.UserId
        }
        let result = await getApi(parameters);
        if (result.status === 200 && Object.keys(result.data).length > 0) {
            setAllBalancesFromOrganizationResult(result.data);
            openModal('allBalancesFromOrganizationModal');
        } else {
            setAllBalancesFromOrganizationResult('empty');
        }
    }

    /*
        - subOrganizationsOfOrganization
    */
    const subOrganizationsOfOrganization = async (value) => {
        if (value.UserId in subOrganizationsOfOrganizationResult && subOrganizationsOfOrganizationResult[value.UserId] !== undefined) {
            setSubOrganizationsOfOrganizationResult(prev => ({ ...prev, [value.UserId]: undefined }));
        } else {
            let parameters = {
                ctrl: 'userAgents',
                method: 'GetSubOrganizationsOfOrganization',
                query: value.UserId
            }
            let result = await getApi(parameters);
            if (result.status === 200 && Object.keys(result.data).length > 0) {
                setSubOrganizationsOfOrganizationResult(prev => ({ ...prev, [value.UserId]: result.data }));
            } else {
                setSubOrganizationsOfOrganizationResult('empty');
            }
        }
    }

    /*
        - modal
    */
    const openModal = (modal) => {
        document.querySelector(`.${modal}`).classList.remove('d-none');
    }

    if (subOrganizationsResult === 'loading') {
        return (
            <Image
                className={`d-block mx-auto`}
                src={LoadingCustomSVG}
                ms={{
                    width: '40px',
                    height: '40px'
                }} />
        );
    }

    if (subOrganizationsResult === 'empty') {
        return (
            <React.Fragment>
                <Box>
                    <Image
                        className={`mx-auto`}
                        src={EmptySVG}
                        ms={{
                            display: 'block',
                            width: '120px',
                            height: '120px'
                        }} />
                    <Typography
                        className={`d-block text-center`}
                        component='h2'>
                        لیست سازمان‌های زیر مجوعه شما خالی است :(
                    </Typography>
                    <Box
                        className={`my-md`} />
                    <Typography
                        className={`d-block text-center`}
                        component='strong'>
                        تاکنون هیچ عضوی را ثبت نکرده اید!
                    </Typography>
                </Box>
            </React.Fragment>
        );
    }

    if (subOrganizationsResult !== 'empty') {
        return (
            <React.Fragment>
                <Grid>
                    <Grid.Wrapper>
                        <Grid.Item
                            size='col-12'>
                            <Box
                                ms={{
                                    '@media(max-width:768px)': {
                                        overflowX: 'scroll'
                                    }
                                }}>
                                <Box
                                    ms={{
                                        minWidth: '768px'
                                    }}>
                                    <Box
                                        className={`d-inline-block w-100 my-sm mt-0 px-xl py-lg rounded-sm`}
                                        ms={{
                                            backgroundColor: 'var(--gray-light)'
                                        }}>
                                        <Box
                                            className={`d-inline-block w-25`}>
                                            <Typography>
                                                نام سازمان
                                            </Typography>
                                        </Box>
                                        <Box
                                            className={`d-inline-block w-25`}>
                                            <Typography>
                                                شماره همراه
                                            </Typography>
                                        </Box>
                                        <Box
                                            className={`d-inline-block w-25`}>
                                            <Typography>
                                                ایمیل
                                            </Typography>
                                        </Box>
                                        <Box
                                            className={`d-inline-block w-25`} />
                                    </Box>
                                    <Box
                                        className={`border-solid border-light rounded-sm`}
                                        ms={{
                                            backgroundColor: 'var(--white)'
                                        }}>
                                        {subOrganizationsResult.Data.map((parentObj, index) => {
                                            return (
                                                <Box
                                                    key={index}>
                                                    <Box
                                                        className={`d-flex justify-content-between px-lg py-md border-solid-bottom border-light`}>
                                                        <Box
                                                            className={`w-25`}>
                                                            {parentObj.HasSubset &&
                                                                <Image
                                                                    onClick={() => subOrganizationsOfOrganization(parentObj)}
                                                                    className={`d-inline-block pointer`}
                                                                    src={ChevronDownBlue}
                                                                    ms={{
                                                                        width: '8px',
                                                                        height: '8px'
                                                                    }} />
                                                            }
                                                            <Box
                                                                className={`d-inline mx-sm mr-0`} />
                                                            <Typography>
                                                                {parentObj.FullName}
                                                            </Typography>
                                                            <Box
                                                                className={`d-inline mx-sm mr-0`} />
                                                            {parentObj.IsAgent &&
                                                                <Badge>
                                                                    نماینده
                                                                </Badge>
                                                            }
                                                        </Box>
                                                        <Box
                                                            className={`w-25`}>
                                                            {parentObj.Mobile}
                                                        </Box>
                                                        <Box
                                                            className={`w-25`}>
                                                            {parentObj.Email}
                                                        </Box>
                                                        <Box
                                                            className={`d-flex align-item-center justify-content-end w-25`}>
                                                            {!parentObj.IsAgent &&
                                                                <Image
                                                                    onClick={() => allBalancesFromOrganizationHandler(parentObj)}
                                                                    className={'pointer'}
                                                                    src={ObserverSVG}
                                                                    ms={{
                                                                        width: '16px',
                                                                        height: '16px'
                                                                    }} />
                                                            }
                                                        </Box>
                                                    </Box>
                                                    {subOrganizationsOfOrganizationResult[parentObj.UserId] !== undefined && subOrganizationsOfOrganizationResult[parentObj.UserId].map((childObj, index) => {
                                                        return (
                                                            <Box
                                                                key={index}
                                                                className={`px-lg pl-0`}
                                                                ms={{
                                                                    backgroundColor: 'var(--gray-ultra-light)'
                                                                }}>
                                                                <Box
                                                                    className={`d-flex justify-content-between px-lg py-md border-solid-bottom border-light`}>
                                                                    <Box
                                                                        className={`w-25`}>
                                                                        {childObj.HasSubset &&
                                                                            <Image
                                                                                onClick={() => subOrganizationsOfOrganization(childObj)}
                                                                                className={`d-inline-block pointer`}
                                                                                src={ChevronDownBlue}
                                                                                ms={{
                                                                                    width: '8px',
                                                                                    height: '8px'
                                                                                }} />
                                                                        }
                                                                        <Box
                                                                            className={`d-inline mx-sm mr-0`} />
                                                                        <Typography>
                                                                            {childObj.FullName}
                                                                        </Typography>
                                                                        <Box
                                                                            className={`d-inline mx-sm mr-0`} />
                                                                        {childObj.IsAgent &&
                                                                            <Badge>
                                                                                نماینده
                                                                            </Badge>
                                                                        }
                                                                    </Box>
                                                                    <Box
                                                                        className={`w-25`}>
                                                                        {childObj.Mobile}
                                                                    </Box>
                                                                    <Box
                                                                        className={`w-25`}>
                                                                        {childObj.Email}
                                                                    </Box>
                                                                    <Box
                                                                        className={`d-flex justify-content-end align-content-center w-25`}>
                                                                        {!childObj.IsAgent &&
                                                                            <Image
                                                                                onClick={() => allBalancesFromOrganizationHandler(childObj)}
                                                                                className={'pointer'}
                                                                                src={ObserverSVG}
                                                                                ms={{
                                                                                    width: '16px',
                                                                                    height: '16px'
                                                                                }} />
                                                                        }
                                                                    </Box>
                                                                </Box>
                                                                {subOrganizationsOfOrganizationResult[childObj.UserId] !== undefined && subOrganizationsOfOrganizationResult[childObj.UserId].map((childObj, index) => {
                                                                    return (
                                                                        <Box
                                                                            key={index}
                                                                            className={`px-lg pl-0`}
                                                                            ms={{
                                                                                backgroundColor: 'var(--gray-ultra-light)'
                                                                            }}>
                                                                            <Box
                                                                                className={`d-flex justify-content-between px-lg py-md border-solid-bottom border-light`}>
                                                                                <Box
                                                                                    className={`w-25`}>
                                                                                    {childObj.HasSubset &&
                                                                                        <Image
                                                                                            onClick={() => subOrganizationsOfOrganization(childObj)}
                                                                                            className={`d-inline-block pointer`}
                                                                                            src={ChevronDownBlue}
                                                                                            ms={{
                                                                                                width: '8px',
                                                                                                height: '8px'
                                                                                            }} />
                                                                                    }
                                                                                    <Box
                                                                                        className={`d-inline mx-sm mr-0`} />
                                                                                    <Typography>
                                                                                        {childObj.FullName}
                                                                                    </Typography>
                                                                                    <Box
                                                                                        className={`d-inline mx-sm mr-0`} />
                                                                                    {childObj.IsAgent &&
                                                                                        <Badge>
                                                                                            نماینده
                                                                                        </Badge>
                                                                                    }
                                                                                </Box>
                                                                                <Box
                                                                                    className={`w-25`}>
                                                                                    {childObj.Mobile}
                                                                                </Box>
                                                                                <Box
                                                                                    className={`w-25`}>
                                                                                    {childObj.Email}
                                                                                </Box>
                                                                                <Box
                                                                                    className={`d-flex justify-content-end align-content-center w-25`}>
                                                                                    {!childObj.IsAgent &&
                                                                                        <Image
                                                                                            onClick={() => allBalancesFromOrganizationHandler(childObj)}
                                                                                            className={'pointer'}
                                                                                            src={ObserverSVG}
                                                                                            ms={{
                                                                                                width: '16px',
                                                                                                height: '16px'
                                                                                            }} />
                                                                                    }
                                                                                </Box>
                                                                            </Box>
                                                                        </Box>
                                                                    );
                                                                })}
                                                            </Box>
                                                        );
                                                    })}
                                                </Box>
                                            );
                                        })}
                                        <Box
                                            className={`d-flex justify-content-center rounded-sm rounded-top-right-0 rounded-top-left-0`}
                                            ms={{
                                                height: '56px',
                                                backgroundColor: 'var(--gray-ultra-light)'
                                            }}>
                                            <Box
                                                className={`d-flex justify-content-center align-item-center`}
                                                ms={{
                                                    gap: '16px'
                                                }}>
                                                <Button
                                                    onClick={() => paginationProps(-1)}
                                                    className={`p-0 rounded-lg`}
                                                    variant='outlined'
                                                    color='primary'
                                                    ms={{
                                                        width: '30px !important',
                                                        height: '30px !important',
                                                        backgroundColor: 'var(--white) !important',
                                                        borderColor: 'var(--white) !important',
                                                        boxShadow: 'var(--shadow-dark)'
                                                    }}>
                                                    <Image
                                                        src={PaginationRightSVG} />
                                                </Button>
                                                <Typography
                                                    className={`text-primary`}>
                                                    {subOrganizationsResult.PageIndex} / {Math.ceil(subOrganizationsResult.TotalItems / subOrganizationsResult.PageSize)}
                                                </Typography>
                                                <Button
                                                    onClick={() => paginationProps(1)}
                                                    className={`p-0 rounded-lg`}
                                                    variant='outlined'
                                                    color='primary'
                                                    ms={{
                                                        width: '30px !important',
                                                        height: '30px !important',
                                                        backgroundColor: 'var(--white) !important',
                                                        borderColor: 'var(--white) !important',
                                                        boxShadow: 'var(--shadow-dark)'
                                                    }}>
                                                    <Image
                                                        src={PaginationLeftSVG} />
                                                </Button>
                                            </Box>
                                        </Box>
                                    </Box>
                                </Box>
                            </Box>
                        </Grid.Item>
                    </Grid.Wrapper>
                </Grid>
                <Modal
                    className={`allBalancesFromOrganizationModal`}>
                    <Modal.Wrapper
                        size='xs'
                        ms={{
                            '@media(max-width:576px)': {
                                width: '100% !important'
                            }
                        }}>
                        <Modal.Header
                            className={`my-md mt-0 border-solid-bottom border-light`}>
                            اطلاعات بیشتر
                            <Box />
                        </Modal.Header>
                        <Alert
                            className={`position-static`}
                            color='warning'
                            ms={{
                                boxShadow: 'none'
                            }}>
                            تمامی قیمت‌ها به تومان می باشد.
                        </Alert>
                        {subAllBalancesFromOrganizationResult !== 'empty' &&
                            <Box
                                className={`p-sm`}
                                component='form'>
                                <Grid>
                                    <Grid.Wrapper>
                                        <Grid.Item
                                            size='col-6'>
                                            <Typography
                                                className={`d-block text-bold`}>
                                                کل اعتبار
                                            </Typography>
                                            {(subAllBalancesFromOrganizationResult.CreditLimit / 10).toLocaleString()}
                                        </Grid.Item>
                                        <Grid.Item
                                            size='col-6'>
                                            <Typography
                                                className={`d-block text-bold`}>
                                                موجودی اعتبار
                                            </Typography>
                                            {(subAllBalancesFromOrganizationResult.CreditBalance / 10).toLocaleString()}
                                        </Grid.Item>
                                        <Grid.Item
                                            size='col-6'>
                                            <Typography
                                                className={`d-block text-bold`}>
                                                بدهی قابل پرداخت
                                            </Typography>
                                            {(subAllBalancesFromOrganizationResult.CreditDebt / 10).toLocaleString()}
                                        </Grid.Item>
                                        <Grid.Item
                                            size='col-6'>
                                            <Typography
                                                className={`d-block text-bold`}>
                                                موجودی کیف پول
                                            </Typography>
                                            {(subAllBalancesFromOrganizationResult.WalletBalance / 10).toLocaleString()}
                                        </Grid.Item>
                                        <Grid.Item
                                            size='col-6'>
                                            <Typography
                                                className={`d-block text-bold`}>
                                                غیر قابل برداشت (ویژه خرید از IHO)
                                            </Typography>
                                            {(subAllBalancesFromOrganizationResult.BlockBalance / 10).toLocaleString()}
                                        </Grid.Item>
                                        <Grid.Item
                                            size='col-6'>
                                            <Typography
                                                className={`d-block text-bold`}>
                                                قابل برداشت
                                            </Typography>
                                            {(subAllBalancesFromOrganizationResult.CashBalance / 10).toLocaleString()}
                                        </Grid.Item>
                                        <Grid.Item
                                            size='col-6'>
                                            <Typography
                                                className={`d-block text-bold`}>
                                                کل شارژ
                                            </Typography>
                                            {(subAllBalancesFromOrganizationResult.ChargedPrice / 10).toLocaleString()}
                                        </Grid.Item>
                                        <Grid.Item
                                            size='col-6'>
                                            <Typography
                                                className={`d-block text-bold`}>
                                                شارژ استفاده شده
                                            </Typography>
                                            {(subAllBalancesFromOrganizationResult.UsedPrice / 10).toLocaleString()}
                                        </Grid.Item>
                                        <Grid.Item
                                            size='col-6'>
                                            <Typography
                                                className={`d-block text-bold`}>
                                                شارژ باقی مانده
                                            </Typography>
                                            {(subAllBalancesFromOrganizationResult.BalancePrice / 10).toLocaleString()}
                                        </Grid.Item>
                                    </Grid.Wrapper>
                                </Grid>
                            </Box>
                        }
                    </Modal.Wrapper>
                </Modal>
            </React.Fragment >
        );
    }

}

export default List;